module.exports = __webpack_public_path__ + "img/PaymentActive.dc9db98a.svg";